import { useState, useEffect } from "react";
import { fetchAudioSnippets } from "../services/audioSnippetService";

/**
 * Hook to fetch and manage audio snippet data
 * @param {Object} options - Query options for filtering and pagination
 * @returns {Object} { audioSnippets, loading, error, refetch }
 */
export const useAudioSnippetData = (options = {}) => {
  const [audioSnippets, setAudioSnippets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const loadAudioSnippets = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchAudioSnippets(options);
      setAudioSnippets(data);
      
      // Estimate total count based on results
      // If we get a full page, there might be more
      const estimatedTotal = data.length === options.limit 
        ? ((options.skip || 0) + data.length + 1) // At least one more page
        : (options.skip || 0) + data.length; // This is the last page
      
      setTotalCount(estimatedTotal);
    } catch (err) {
      console.error("Error loading audio snippets:", err);
      setError(err.response?.data?.detail || "Failed to load audio snippets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAudioSnippets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.skip, options.limit, options.start_date, options.end_date, options.user_id]);

  return {
    audioSnippets,
    loading,
    error,
    totalCount,
    refetch: loadAudioSnippets,
  };
};

